import { Component } from '@angular/core';

@Component({
  selector: 'app-debug-rect',
  imports: [],
  templateUrl: './debug-rect.component.html',
  styleUrl: './debug-rect.component.css',
})
export class DebugRectComponent {}
